/* eslint-disable */
export default {
    text (output) {
        return Drupal.t(output)
    },
    getSettings () {
        if(drupalSettings){
           return drupalSettings
        }
        return {}
    },
    getStore () {
        if(drupalSettings){
            let storeSettings = drupalSettings.store
            return {
                address: storeSettings.address.address_line1,
                calenderid: storeSettings.etermin_id,
                city: storeSettings.address.locality,
                federalstate: storeSettings.federal_state,
                phone: storeSettings.tel,
                id: storeSettings.nid,
                openinghours: storeSettings.opening_hours ? storeSettings.opening_hours : [],
                lunchbreak: storeSettings.lunch_break ? storeSettings.lunch_break : [],
                specialbushours: storeSettings.special_bushours ? storeSettings.special_bushours : [],
                holiday: storeSettings.holiday ? storeSettings.holiday : '',
                title: storeSettings.title,
                zip: storeSettings.address.postal_code,
                path : storeSettings.path,
                geolocation: {
                    lat: storeSettings.geolocation.lat,
                    lng: storeSettings.geolocation.lng
                }
            }
        }
        return {}
    }
}